import update from 'immutability-helper';

import { SET, ADDED, UPDATED, DELETED } from './actions';
import * as questionsActions from "../questions/actions";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.baskets;

    case ADDED:
      return {
        ...state,
        [action.basket.id]: action.basket
      };

    case UPDATED:
      return update(state, {
        [action.basket.id]: {
          $set: action.basket
        }
      });
    case DELETED:
      return update(state, {
        $unset: [action.basket.id]
      });

    case questionsActions.TYPE_UPDATED:
      const ids = [];

      _.each(state, basket => {
        if (basket.question.id === action.expiredId)
          ids.push(basket.id);
      });

      return update(state, {
        $unset: ids
      });

    default:
      return state;
  }
};